var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentWrap,{tag:"component",staticClass:"tag",class:( _obj = {}, _obj[("tag-" + _vm.type)] = _vm.type != 'default', _obj['is-ellipsis'] =  _vm.isEllipsis, _obj ),attrs:{"to":_vm.to}},[_c('span',{staticClass:"tag-text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }